import ChatInputControl from "./ChatInput";

const ChatInputWrapper = ({
  isThreadScreen,

  // Common props for ChatInputControl
  handleclickAttherate,
  handleMessageSend,
  handleOnChangeNewMessage,
  newMessages,
  handleClickYouTube,
  setFileAttachment,
  handleClickGoogle,
  handleClickCloudStorage,
  fileAttachment,
  attachment,
  setAttachment,
  isTaskTypeModalOpen,
  isTaskUpdateOpen,
  setIsTaskTypeModalOpen,
  setReplyParentMsg,
  replyParentMsg,
  selectedGroup,
  handleAssignTask,
  setMessageType,
  selectRecipientsDrawerOpen,
  taskAssignedUser,
  taskModalDeatils,
  isThreadScreenFromTaskApproval,
  isPrivateChatOn,
  setTaskModalDeatils,
  selectedRecipients,
  setPricingDrawerOpen,
  stepper,
  isDisableAssignTaskBtn,

}) => {
  return (
    <ChatInputControl
      handleclickAttherate={handleclickAttherate}
      handleMessageSend={handleMessageSend}
      handleOnChangeNewMessage={handleOnChangeNewMessage}
      newMessages={newMessages}
      handleClickYouTube={handleClickYouTube}
      setFileAttachment={setFileAttachment}
      handleClickGoogle={handleClickGoogle}
      handleClickCloudStorage={handleClickCloudStorage}
      fileAttachment={fileAttachment}
      attachment={attachment}
      isTaskTypeModalOpen={isTaskTypeModalOpen}
      setAttachment={setAttachment}
      setIsTaskTypeModalOpen={setIsTaskTypeModalOpen}
      replyParentMsg={replyParentMsg}
      setReplyParentMsg={setReplyParentMsg}
      selectedGroup={selectedGroup}
      handleAssignTask={handleAssignTask}
      setMessageType={setMessageType}
      selectRecipientsDrawerOpen={selectRecipientsDrawerOpen}
      taskAssignedUser={taskAssignedUser}
      taskModalDeatils={taskModalDeatils}
      isThreadScreenFromTaskApproval={isThreadScreenFromTaskApproval}
      isPrivateChatOn={isPrivateChatOn}
      isTaskUpdateOpen={isTaskUpdateOpen}
      isThreadScreen={isThreadScreen}
      setTaskModalDeatils={setTaskModalDeatils}
      selectedRecipients={selectedRecipients}
      setPricingDrawerOpen={setPricingDrawerOpen}
      stepper={stepper}
      isDisableAssignTaskBtn={isDisableAssignTaskBtn}
    />
  );
};

export default ChatInputWrapper;
